import React, { useEffect, useRef, useState } from "react";
import { Link ,useNavigate} from "react-router-dom";
import ApexCharts from "apexcharts";
import { Card, Row, Col, Typography, Badge, Button, } from "antd";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const PayrollDashboard = () => {
  const chartRefPayrollCosts = useRef(null);
  const chartRefSalaryTrend = useRef(null);
  const { Title, Text } = Typography;
  const maximizeBtnRef = useRef(null);

  const [payrollPeriod] = useState("July 2024");
  const navigate = useNavigate();
  const [isFullScreen, setFullScreen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const apiUrl = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem("token");

  const handleClick = async () => {
    setIsLoading(true); // Set loading to true
  
    try {
      const response = await axios.post(
        `${apiUrl}/payroll/run-payroll`,
        {
          payroll_month: payrollData.payroll_month, // Pass required data
          payroll_id: payrollData.payroll_id, // Include the ID in the body
        },
        {
          headers: {
            Authorization: `Bearer ${token}`, // Add authentication headers
          },
        }
      );
  
      // Access nested API response data
      const responseData = response.data;
      if (responseData.status === "draft") {
        toast.success(responseData.message || "Payroll run initiated successfully!");
        navigate(`/run-payroll?id=${payrollData.payroll_id}`); // Redirect with query params
      } else {
        toast.warn(responseData.message || "Unable to initiate payroll. Please check settings.");
      }
    } catch (error) {
      console.error("Error initiating payroll run:", error);
      toast.error("Failed to initiate payroll run. Please try again.");
    } finally {
      setIsLoading(false); // Reset loading regardless of success or failure
    }
  };
  
  


const [stats, setStats] = useState({
  totalEmployees: 0,
  incompleteProfile: 0,
  approvalPending: 0,
  undefinedSalary: 0,
});

  const [payrollData, setPayrollData] = useState(null);

  useEffect(() => {
    const validatePayroll = async () => {
      try {
        const response = await axios.get(`${apiUrl}/payroll/validate-payroll`, {
          headers: { Authorization: `Bearer ${token}` },
        });
  
        const data = response.data;
        if (data.status === "setting-pending") {
          navigate("/payroll-settings");
        } else {

          if (data.stats) {
            setStats(data.stats); // Set the stats in state
          }
          setPayrollData(data);
        }
      } catch (error) {
        console.error("Error validating payroll:", error);
        toast.error("Failed to validate payroll. Please try again.");
      }
    };
  
    validatePayroll();
  }, [apiUrl, token, navigate]);
  

  // Chart Configurations
  useEffect(() => {
    const payrollCostOptions = {
      series: [40000, 30000, 25000, 50000],
      chart: { type: "donut", height: 250 },
      labels: ["HR", "Engineering", "Sales", "Marketing"],
      colors: ["#FFC38F", "#77D882", "#FF902F", "#4B77A9"],
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: { width: 300 },
            legend: { position: "bottom" },
          },
        },
      ],
    };
    const payrollChart = new ApexCharts(chartRefPayrollCosts.current, payrollCostOptions);
    payrollChart.render();
    return () => payrollChart.destroy();
  }, []);



  
    useEffect(() => {
      const handleClick = () => {
        if (!document.fullscreenElement) {
          document.documentElement.requestFullscreen();
          setFullScreen(true);
        } else {
          if (document.exitFullscreen) {
            document.exitFullscreen();
            setFullScreen(false);
          }
        }
      };
  
      const cleanup = () => {
        if (isFullScreen && document.exitFullscreen) {
          document.exitFullscreen();
          setFullScreen(false);
        }
      };
  
      const maximizeBtn = maximizeBtnRef.current;
      maximizeBtn.addEventListener('click', handleClick);
  
      return () => {
        maximizeBtn.removeEventListener('click', handleClick);
        cleanup();
      };
    }, [isFullScreen]);
  
  
  useEffect(() => {
    const salaryTrendOptions = {
      series: [{ name: "Salary", data: [120000, 130000, 125000, 135000, 140000, 138000] }],
      chart: { type: "line", height: 300 },
      stroke: { curve: "smooth" },
      xaxis: { categories: ["Apr", "May", "Jun", "Jul", "Aug", "Sep"] },
      colors: ["#FF902F"],
    };
    const salaryTrendChart = new ApexCharts(chartRefSalaryTrend.current, salaryTrendOptions);
    salaryTrendChart.render();
    return () => salaryTrendChart.destroy();
  }, []);

  const handleRunPayroll = () => {
    alert(`Payroll has been initiated for ${payrollPeriod}`);
  };

  return (
    <div className="page-wrapper">
      <div className="content container-fluid pb-0">
        {/* Page Header */}
        <div className="page-header page-top-icons">
          <div className="row align-items-center">
            <div className="col-md-4">
              <Title level={3} style={{ marginBottom: 0 }}>
                Payroll Dashboard
              </Title>
            </div>
            <div className="col-md-8 float-end ms-auto">
              <div className="d-flex justify-content-end">
                <div className="view-icons">
                  <Link to="#" className="btn btn-link">
                    <i className="las la-redo-alt" />
                  </Link>
                  <Link to="#" className="btn btn-link" id="collapse-header" ref={maximizeBtnRef}>
                    <i className="las la-expand-arrows-alt" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Quick Stats Section */}
        <div className="row mt-3">
          {/* Process Pay Run */}
          <div className="col-md-6">
  <Card
    title={
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Title level={4} style={{ marginBottom: 0 }}>
          {payrollData
            ? `Process Pay Run for ${new Date(
                `${payrollData.payroll_month.split('-')[1]}-${payrollData.payroll_month.split('-')[0]}-01`
              ).toLocaleString('default', { month: 'long', year: 'numeric' })}`
            : "Loading..."}
        </Title>
        <Badge
          count={payrollData?.status?.toUpperCase() || "PENDING"}
          style={{
            backgroundColor: payrollData?.status === "ready" ? "#52c41a" : "#ffa940",
            fontSize: "12px",
            height: "22px",
            lineHeight: "22px",
          }}
        />
      </div>
    }
    style={{
      borderLeft: "5px solid #1890ff",
      borderRadius: "8px",
    }}
    className="payroll-card"
  >
    <Row>
      <Col span={8}>
        <Text strong>EMPLOYEES' NET PAY:</Text>
        <br />
        <Text type="secondary">
          {["ready", "draft","approved"].includes(payrollData?.status) ? payrollData.total_salary : "YET TO PROCESS"}
        </Text>
      </Col>
      <Col span={8}>
        <Text strong>PAYMENT DATE:</Text>
        <br />
        <Text type="secondary">
          {payrollData?.status === "ready" ? payrollData.payment_date : "YET TO PROCESS"}
        </Text>
      </Col>
      <Col span={8}>
        <Text strong>NO. OF EMPLOYEES:</Text>
        <br />
        <Text type="secondary">
          {["ready", "draft","approved"].includes(payrollData?.status) ? payrollData.total_employees : "YET TO PROCESS"}
        </Text>
      </Col>
    </Row>
    <div style={{ display: "flex", alignItems: "center", marginTop: "15px" }}>

    <Button
  type="primary"
  style={{ width: "200px", marginTop: "15px" }}
  onClick={() => {
    if (payrollData?.status === "draft") {
      navigate(`/run-payroll?id=${payrollData.payroll_id}`); // Redirect for draft status
    } else if (payrollData?.status === "ready") {
      handleClick(); // Call handleClick for ready status
    } else if (payrollData?.status === "approved") {
      navigate(`/run-payroll?id=${payrollData.payroll_id}`); // Redirect for approved status
    }
  }}
  disabled={!payrollData} // Disable if payrollData is not available
>
  {isLoading ? (
    <>
      <i
        className="fa fa-spinner fa-spin"
        style={{
          marginRight: "8px",
          fontSize: "16px",
          verticalAlign: "middle",
        }}
      ></i>
      Processing...
    </>
  ) : payrollData?.status === "approved" ? (
    "View Details"
  ) : payrollData?.status === "draft" ? (
    "View Details"
  ) : payrollData?.status === "ready" ? (
    "Start Payroll"
  ) : (
    "View Details"
  )}
</Button>



      {payrollData?.days_difference !== undefined && (
        <Text
          style={{
            marginLeft: "16px",
            color: payrollData.days_difference > 0 ? "#ff4d4f" : "#52c41a", // Red for delay, green for dues
            fontWeight: "bold",
          }}
        >
          {payrollData.days_difference > 0
            ? `Payroll delayed by ${payrollData.days_difference} days.`
            : `Payroll due in ${Math.abs(payrollData.days_difference)} days.`}
        </Text>
      )}
    </div>
  </Card>
</div>

<div className="col-md-6">
  <div className="row g-2">
    {/* First Row */}
    <div className="col-6">
      <Card
        className="text-center"
        style={{
          padding: "10px",
          height: "100px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          borderLeft: "3px solid #007bff", // Add right border with color
        }}
      >
        <Text type="primary" style={{ fontSize: "14px" }}>Total Employees</Text>
        <Title level={4} style={{ margin: 0 }}>{stats.totalEmployees}</Title>
        <Button type="link" style={{ fontSize: "12px", padding: "2px 0" }}>
          View Details
        </Button>
      </Card>
    </div>
    <div className="col-6">
      <Card
        className="text-center"
        style={{
          padding: "10px",
          height: "100px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          borderLeft: "3px solid #28a745", // Add right border with color
        }}
      >
        <Text type="primary" style={{ fontSize: "14px" }}>Incomplete Profiles</Text>
        <Title level={4} style={{ margin: 0 }}>{stats.incompleteProfile}</Title>
        <Button type="link" style={{ fontSize: "12px", padding: "2px 0" }}>
          View Details
        </Button>
      </Card>
    </div>

    {/* Second Row */}
    <div className="col-6">
      <Card
        className="text-center"
        style={{
          padding: "10px",
          height: "100px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          borderLeft: "3px solid #ffc107", // Add right border with color
        }}
      >
        <Text type="primary" style={{ fontSize: "14px" }}>Undefined Salaries</Text>
        <Title level={4} style={{ margin: 0 }}>{stats.undefinedSalary}</Title>
        <Button type="link" style={{ fontSize: "12px", padding: "2px 0" }}>
          Take Actions
        </Button>
      </Card>
    </div>
    <div className="col-6">
      <Card
        className="text-center"
        style={{
          padding: "10px",
          height: "100px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          borderLeft: "3px solid #dc3545", // Add right border with color
        }}
      >
        <Text type="primary" style={{ fontSize: "14px" }}>Pending Approvals</Text>
        <Title level={4} style={{ margin: 0 }}>{stats.approvalPending}</Title>
        <Button type="link" style={{ fontSize: "12px", padding: "2px 0" }}>
          Review
        </Button>
      </Card>
    </div>
  </div>
</div>





  
        </div>

        {/* Charts Section */}
        <div className="row mt-4">
          <div className="col-md-6">
            <Card>
              <Title level={4}>Payroll Overview (By Department)</Title>
              <div ref={chartRefPayrollCosts} />
            </Card>
          </div>
          <div className="col-md-6">
            <Card>
              <Title level={4}>Salary Trend (April - March)</Title>
              <div ref={chartRefSalaryTrend} />
            </Card>
          </div>
        </div>

        {/* Additional Actions */}
    
      </div>
    </div>
  );
};

export default PayrollDashboard;
